import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import * as orderHandler from "@/js/order/order.js";
import { REGULAR_BOTTLING, orderStatus, expeditionMethods, listTerms, listContinents, listCurrencies, listUserGroups, upsErrors, casingWines, listWineTypes, listWineRangeAccessibility, wineStockStatus, buyLimitErrors, STOCK_PART, COUNTRIES } from "@/js/lists.ts";
import { ERROR_DATA } from "@/js/forms.js";
import { casingForAdmin, wineNaming } from "@/js/wine/wine.js";
import "vue-loading-overlay/dist/vue-loading.css";
import { hasRole, isHolding } from "@/js/http/auth.js";
import { getFullNameUserHtml, getFullNameUser, userGroupName } from "@/js/user/user.js";
import { getPriceValueInUsedCurrencyForCartAndExplore, getSymbolCurrency, formatPrice, roundToTwoDigit } from "@/js/currency/currencies.js";
import { scrollTo } from "@/js/animation.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import WineStockListModal from "@/components/products/WineStockListModal.vue";
import WineDiscountTooltip from "@/components/products/WineDiscountTooltip.vue";
import EditOrderItemPriceDialog from "@/components/order/AdminSummarySubs/EditOrderItemPriceDialog.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import StorageTermsReference from "@/components/common/StorageTermsReference.vue";
export default {
  name: "AdminFinalizeCart",
  components: {
    "wine-naming": WineNaming,
    confirm: confirmationComponent,
    WineStockListModal: WineStockListModal,
    WineDiscountTooltip: WineDiscountTooltip,
    EditOrderItemPriceDialog: EditOrderItemPriceDialog,
    StorageTermsReference: StorageTermsReference,
    ErrorModal: ErrorModal
  },
  props: {
    baseModel: Object,
    loggedUserData: Object
  },
  data: function data() {
    return {
      isChangingQuantity: false,
      isFetchingShippingCosts: false,
      isCollapsed: true,
      deliveryAddressFaultedMessage: null,
      quantityToggleKey: false,
      order: {
        id_order: null,
        buyer_term: null,
        items: [],
        id_user: null,
        amount_ex_vat: null,
        total_amount: null,
        status: null,
        expedition_method: 0,
        expedition_methods: {},
        delivery_address: null,
        delivery_instructions: null,
        billing_address: null,
        amount_shipping: null,
        user: null
      },
      isShippingQuantity: false,
      editShippingQuantityToken: null,
      isEditingShippingQuantity: false,
      imagesBroken: [],
      thirdPartyUserSelected: null,
      expedition_methods: [],
      expedition_methods_ref: expeditionMethods,
      expeditionMethods: expeditionMethods,
      errorLabels: {
        shipping: {},
        tastingPhoto: "",
        terms: "",
        user_selected: "",
        quantity_orders: []
      },
      errorMessages: {
        mandatory: "This field is required",
        order: {
          quantity: "You don't reach the minimum per order"
        },
        shippingType: {
          required: "You must select a shipping type"
        },
        tastingPhoto: {
          required: "You must notify the customer to take a photo of some bottles at time of tasting"
        }
      },
      mustRecalculateCharges: true,
      canManageUsers: false,
      updateDeliveryInstructionsToken: null,
      editingDeliveryInstructions: false,
      isSetDeliveryAddressAsDefaultForUserAddress: false,
      checkboxTastingPhoto: [],
      storageLocations: {
        storageLocationsList: [],
        warehouses: []
      },
      lastExpeditionMethod: null,
      editOrderItemPriceDialogShown: false,
      changeWineStockCancellationToken: null,
      wineStockKey: null,
      currentWine: null,
      currentItemForWineStockChanged: null,
      currentGroupedItemsForWineStockChanged: null,
      currentQuantity: 1,
      currentCasingId: null,
      initialCurrency: null,
      updateOrderCurrencyToken: null,
      editingOrderCurrency: false,
      isUpdatingOrderCurrency: false,
      orderStatus: orderStatus,
      listTerms: listTerms,
      casingWines: casingWines,
      wineStockStatus: wineStockStatus,
      filterIntegerKey: filterIntegerKey,
      listUserGroups: listUserGroups,
      listCurrencies: listCurrencies,
      wineNaming: wineNaming,
      STOCK_PART: STOCK_PART,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isOrderForIndividualUs: function isOrderForIndividualUs() {
      var _this$order, _this$order2;
      return ((_this$order = this.order) === null || _this$order === void 0 || (_this$order = _this$order.delivery_address) === null || _this$order === void 0 ? void 0 : _this$order.country.iso_2) === "US" && ((_this$order2 = this.order) === null || _this$order2 === void 0 || (_this$order2 = _this$order2.user) === null || _this$order2 === void 0 ? void 0 : _this$order2.user_group) === "USER";
    },
    isInboundAvailable: function isInboundAvailable() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_DELIVERIES) && this.order.expedition_method !== expeditionMethods.CELLAR_STORAGE.id;
    },
    isGreatExport: function isGreatExport() {
      var _this$order3;
      return !((_this$order3 = this.order) !== null && _this$order3 !== void 0 && (_this$order3 = _this$order3.delivery_address) !== null && _this$order3 !== void 0 && (_this$order3 = _this$order3.country) !== null && _this$order3 !== void 0 && _this$order3.european_union_member);
    },
    isConcernedByVat: function isConcernedByVat() {
      var _this$order4;
      return ((_this$order4 = this.order) === null || _this$order4 === void 0 ? void 0 : _this$order4.amount_vat) > 0;
    },
    isAuthorizedToEditItemPrice: function isAuthorizedToEditItemPrice() {
      return hasRole(process.env.VUE_APP_ROLES_EDIT_ORDER_ITEM_PRICE);
    },
    groupedItemsByDeparture: function groupedItemsByDeparture() {
      var _this$order5,
        _this2 = this;
      if (!this.expedition_methods.length || !((_this$order5 = this.order) !== null && _this$order5 !== void 0 && (_this$order5 = _this$order5.items) !== null && _this$order5 !== void 0 && _this$order5.length)) return [];
      return this.order.items.reduce(function (acc, x) {
        var shippingMethods = _this2.expedition_methods.filter(function (e) {
          return e.itemIds.includes(x.id_item);
        });
        var current = _objectSpread(_objectSpread({}, x), {}, {
          shippingMethods: shippingMethods
        });
        var index = acc[0].findIndex(function (i) {
          return i.some(function (ii) {
            return ii.shippingMethods.some(function (s) {
              return s.itemIds.includes(x.id_item);
            });
          });
        });
        if (index >= 0) acc[0][index] = [].concat(_toConsumableArray(acc[0][index]), [current]);else acc[0] = [].concat(_toConsumableArray(acc[0]), [[current]]);
        return acc;
      }, [[]])[0];
    },
    defaultShippingIncludedInItemsByDeparture: function defaultShippingIncludedInItemsByDeparture() {
      var _this3 = this;
      if (!this.groupedItemsByDeparture.length) return [];
      return this.groupedItemsByDeparture.reduce(function (acc, group) {
        group.forEach(function (item) {
          var warehouseId = _this3.getAnyShippingMethod(group).departureWarehouseId;
          var shippingCost = item.unitDefaultShippingCurrency * item.quantity;
          var existingWarehouse = acc.find(function (entry) {
            return entry.warehouseId === warehouseId;
          });
          if (existingWarehouse) {
            existingWarehouse.totalDefaultShippingCurrency += shippingCost;
          } else {
            acc.push({
              warehouseId: warehouseId,
              totalDefaultShippingCurrency: shippingCost
            });
          }
        });
        return acc;
      }, []);
    },
    orderHasMultipleDepartures: function orderHasMultipleDepartures() {
      var _this$groupedItemsByD;
      return ((_this$groupedItemsByD = this.groupedItemsByDeparture) === null || _this$groupedItemsByD === void 0 ? void 0 : _this$groupedItemsByD.length) > 1;
    },
    hasBlockingNetworkError: function hasBlockingNetworkError() {
      var _this$order6, _this$groupedItemsByD2;
      return !this.isFetchingShippingCosts && ((_this$order6 = this.order) === null || _this$order6 === void 0 || (_this$order6 = _this$order6.items) === null || _this$order6 === void 0 ? void 0 : _this$order6.length) > 0 && !((_this$groupedItemsByD2 = this.groupedItemsByDeparture) !== null && _this$groupedItemsByD2 !== void 0 && _this$groupedItemsByD2.length);
    },
    nbBottles: function nbBottles() {
      var _this$order$items;
      return (_this$order$items = this.order.items) === null || _this$order$items === void 0 ? void 0 : _this$order$items.reduce(function (acc, item) {
        return acc + item.quantity;
      }, 0);
    },
    getOrderNbItems: function getOrderNbItems() {
      var nbItems = 0;
      this.order.items.forEach(function (x) {
        nbItems += x.quantity;
      });
      return nbItems;
    },
    hasInactiveItems: function hasInactiveItems() {
      return this.order.items.some(function (x) {
        return x.hasClosedStock || !x.wine.is_active || x.wine.deleted || x.wine.isClosedStock;
      });
    },
    itemsRequiringTastingPhoto: function itemsRequiringTastingPhoto() {
      var _this$order$items$fil, _this$order7;
      return (_this$order$items$fil = (_this$order7 = this.order) === null || _this$order7 === void 0 ? void 0 : _this$order7.items.filter(function (x) {
        return x.wine.isTastingPhotoRequired;
      })) !== null && _this$order$items$fil !== void 0 ? _this$order$items$fil : [];
    },
    canChangeCurrency: function canChangeCurrency() {
      var _this$order8, _this$order9, _this$order10, _this$listDefaultCurr;
      return ((_this$order8 = this.order) === null || _this$order8 === void 0 || (_this$order8 = _this$order8.delivery_address) === null || _this$order8 === void 0 || (_this$order8 = _this$order8.country) === null || _this$order8 === void 0 ? void 0 : _this$order8.currency) !== null && ((_this$order9 = this.order) === null || _this$order9 === void 0 || (_this$order9 = _this$order9.delivery_address) === null || _this$order9 === void 0 || (_this$order9 = _this$order9.country) === null || _this$order9 === void 0 ? void 0 : _this$order9.currency) !== "EUR" && ((_this$order10 = this.order) === null || _this$order10 === void 0 || (_this$order10 = _this$order10.delivery_address) === null || _this$order10 === void 0 || (_this$order10 = _this$order10.country) === null || _this$order10 === void 0 ? void 0 : _this$order10.id_country) !== COUNTRIES.USA.id && ((_this$listDefaultCurr = this.listDefaultCurrencies) === null || _this$listDefaultCurr === void 0 ? void 0 : _this$listDefaultCurr.length) > 1;
    },
    listDefaultCurrencies: function listDefaultCurrencies() {
      var _this$order$delivery_,
        _this$order$delivery_2,
        _this$order$factoring,
        _this4 = this;
      var availableCurrencies = [];
      if (((_this$order$delivery_ = this.order.delivery_address) === null || _this$order$delivery_ === void 0 || (_this$order$delivery_ = _this$order$delivery_.country) === null || _this$order$delivery_ === void 0 ? void 0 : _this$order$delivery_.id_country) === COUNTRIES.USA.id) {
        availableCurrencies = ["USD"];
      } else if (((_this$order$delivery_2 = this.order.delivery_address) === null || _this$order$delivery_2 === void 0 || (_this$order$delivery_2 = _this$order$delivery_2.country) === null || _this$order$delivery_2 === void 0 ? void 0 : _this$order$delivery_2.id_country) === COUNTRIES.BAHAMAS.id) {
        availableCurrencies = ["BSD", "USD"];
      } else {
        var _this$order11, _this$order12;
        availableCurrencies.push("EUR");
        if ((_this$order11 = this.order) !== null && _this$order11 !== void 0 && _this$order11.currency) availableCurrencies.push(this.order.currency);
        if ((_this$order12 = this.order) !== null && _this$order12 !== void 0 && (_this$order12 = _this$order12.delivery_address) !== null && _this$order12 !== void 0 && (_this$order12 = _this$order12.country) !== null && _this$order12 !== void 0 && _this$order12.currency) availableCurrencies.push(this.order.delivery_address.country.currency);
      }
      if (((_this$order$factoring = this.order.factoringProvider) === null || _this$order$factoring === void 0 || (_this$order$factoring = _this$order$factoring.currencies) === null || _this$order$factoring === void 0 ? void 0 : _this$order$factoring.length) > 0) {
        availableCurrencies = availableCurrencies.filter(function (x) {
          return _this4.order.factoringProvider.currencies.includes(x);
        });
      }
      return listCurrencies.filter(function (x) {
        return availableCurrencies.includes(x.id);
      });
    },
    userData: function userData() {
      return String.parseForVHtml(getFullNameUserHtml(this.order.user)) + "<br /><span class='text-smaller text-italic'>" + userGroupName(this.order.user) + (this.order.user.sponsorship_code ? " - " + this.order.user.sponsorship_code : "") + "</span>";
    }
  },
  created: function created() {
    var _this$baseModel;
    if (!((_this$baseModel = this.baseModel) !== null && _this$baseModel !== void 0 && _this$baseModel.id_order)) {
      this.$router.push({
        name: "userHome"
      });
      return;
    }
    this.$EventBus.$emit("loading", true);
    this.canManageUsers = hasRole(process.env.VUE_APP_ROLES_MANAGE_USER);
    this.order = _objectSpread(_objectSpread({}, this.order), this.baseModel);
    this.computeCasings();
    this.isSetDeliveryAddressAsDefaultForUserAddress = this.isOrderDeliveryInstructionsDefaultUser();
    if (this.order.shipping_quantity != null) {
      this.isShippingQuantity = true;
    }
    this.getChargesForOrder();
    this.thirdPartyUserSelected = orderHandler.getThirdPartyUserSelected();
    this.order.id_user = this.thirdPartyUserSelected.id_user;
    this.dispatchItemsInStorageLocations();
  },
  methods: {
    getAnyGroupedItem: function getAnyGroupedItem(groupedItems) {
      return groupedItems[0];
    },
    getAnyShippingMethod: function getAnyShippingMethod(groupedItems) {
      return this.getAnyGroupedItem(groupedItems).shippingMethods[0];
    },
    isShippingSetAvailable: function isShippingSetAvailable(groupedItems) {
      var _groupItem$shippingMe;
      var groupItem = this.getAnyGroupedItem(groupedItems);
      var expedtionMethod = groupItem.expeditionMethod;
      return !!expedtionMethod && ((_groupItem$shippingMe = groupItem.shippingMethods) === null || _groupItem$shippingMe === void 0 ? void 0 : _groupItem$shippingMe.filter(function (x) {
        return !x.isError && x.expedition_method == expedtionMethod;
      }).length) > 0;
    },
    collapse: function collapse(index) {
      this.isCollapsed = !this.isCollapsed;
      var _this = this;
      this.$nextTick(function () {
        document.querySelector("#order-summary-".concat(index)).scrollIntoView({
          behavior: "smooth",
          block: _this.isCollapsed ? "start" : "end"
        });
      });
    },
    isActiveItem: function isActiveItem(item) {
      return !item.hasClosedStock && item.wine.is_active && !item.wine.deleted && !item.wine.isClosedStock;
    },
    productDetails: function productDetails(wine) {
      var detailsRoute = wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "adminSpiritsDetails" : "adminWineDetails";
      return {
        name: detailsRoute,
        params: {
          id: wine.id_wine
        }
      };
    },
    goToUserEdit: function goToUserEdit(user) {
      return {
        name: "adminUserDetails",
        query: {
          id_user: user.id_user
        }
      };
    },
    getChargesForOrder: function getChargesForOrder() {
      var isRetrying = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var bypassBuyLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.errorLabels.quantity_orders = [];
      this.deliveryAddressFaultedMessage = null;
      this.isFetchingShippingCosts = true;
      this.$EventBus.$emit("loading", true);
      var _this = this;
      var path = "/v1/order";
      if (bypassBuyLimit) path += "?bypassBuyLimits=true";
      return request(path, "put", _this.order, true, "api").then(function (response) {
        return _this.confirmDeliveryAddress().then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this.order = _objectSpread({}, response.data);
                _this.computeCasings();
                orderHandler.setCurrentOrder(response.data);
                return _context.abrupt("return", request("/v1/order/" + _this.order.id_order + "/logistic/", "get", null, true, "api").then(function (db) {
                  _this.computeCharges(db.data);
                  _this.$EventBus.$emit("update-cart");
                  _this.isFetchingShippingCosts = false;
                  if (_this.groupedItemsByDeparture.some(function (x) {
                    return x.some(function (y) {
                      return y.expeditionMethod === expeditionMethods.CELLAR_STORAGE.id;
                    });
                  })) {
                    _this.$EventBus.$emit("loading", true);
                    request("/v1/order", "put", _this.order, true, "api").then(function (orderReponse) {
                      _this.order = _objectSpread(_objectSpread({}, _this.order), orderReponse.data);
                      _this.computeCasings();
                    }).finally(function (_) {
                      _this.$EventBus.$emit("loading", false);
                    });
                  }
                }).catch(function (e) {
                  throw e;
                }));
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))).catch(function (e) {
          var _e$response;
          _this.isFetchingShippingCosts = false;
          if (e !== null && e !== void 0 && (_e$response = e.response) !== null && _e$response !== void 0 && (_e$response = _e$response.data) !== null && _e$response !== void 0 && (_e$response = _e$response.value) !== null && _e$response !== void 0 && _e$response.errorCode && upsErrors[e.response.data.value.errorCode]) {
            _this.deliveryAddressFaultedMessage = upsErrors[e.response.data.value.errorCode];
          } else {
            _this.$toasted.show("An error occured. Please contact an administrator.", {
              type: "error"
            });
          }
        });
      }).catch(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
          var _e$response2, _e$response3;
          var message, isBypassingReachedBuyLimit, _e$response$data$valu, _e$response4, _e$response5, errorMessage;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _this.isFetchingShippingCosts = false;
                if (e !== null && e !== void 0 && (_e$response2 = e.response) !== null && _e$response2 !== void 0 && (_e$response2 = _e$response2.data) !== null && _e$response2 !== void 0 && (_e$response2 = _e$response2.value) !== null && _e$response2 !== void 0 && _e$response2.message) {
                  message = e.response.data.value.message;
                  _this.$toasted.show(message, {
                    type: "warning"
                  });
                } else {
                  _this.$toasted.show("An error occured. Please contact an administrator.", {
                    type: "error"
                  });
                }
                isBypassingReachedBuyLimit = null;
                if (!(hasRole(process.env.VUE_APP_ROLES_BYPASS_ALL_BUY_LIMITS) && (e === null || e === void 0 || (_e$response3 = e.response) === null || _e$response3 === void 0 || (_e$response3 = _e$response3.data) === null || _e$response3 === void 0 || (_e$response3 = _e$response3.value) === null || _e$response3 === void 0 ? void 0 : _e$response3.errorCode) === buyLimitErrors.BUY_LIMIT_REACHED.value)) {
                  _context2.next = 9;
                  break;
                }
                errorMessage = (_e$response$data$valu = e === null || e === void 0 || (_e$response4 = e.response) === null || _e$response4 === void 0 || (_e$response4 = _e$response4.data) === null || _e$response4 === void 0 || (_e$response4 = _e$response4.value) === null || _e$response4 === void 0 ? void 0 : _e$response4.errorMessage) !== null && _e$response$data$valu !== void 0 ? _e$response$data$valu : e === null || e === void 0 || (_e$response5 = e.response) === null || _e$response5 === void 0 || (_e$response5 = _e$response5.data) === null || _e$response5 === void 0 || (_e$response5 = _e$response5.value) === null || _e$response5 === void 0 ? void 0 : _e$response5.message;
                _this.$toasted.clear();
                _context2.next = 8;
                return _this.$refs.confirm.open("Bypass buy limits for order", "".concat(errorMessage, "  ").concat(buyLimitErrors.BUY_LIMIT_REACHED.text), {
                  color: "red"
                });
              case 8:
                isBypassingReachedBuyLimit = _context2.sent;
              case 9:
                if (!(_this.order.id_order && isBypassingReachedBuyLimit)) {
                  _context2.next = 12;
                  break;
                }
                _context2.next = 12;
                return request("/v1/order/".concat(_this.order.id_order, "/bypass"), "put", null, true, "api");
              case 12:
                _this.mustRecalculateCharges = false;
                if (!isBypassingReachedBuyLimit) {
                  _this.order.items = _this.order.items.map(function (x) {
                    return _objectSpread(_objectSpread({}, x), {}, {
                      quantity: x.original_qty,
                      casingId: x.originalCasingId
                    });
                  });
                }
                if (!(isBypassingReachedBuyLimit === false)) {
                  _context2.next = 16;
                  break;
                }
                return _context2.abrupt("return");
              case 16:
                if (_this.isChangingQuantity && !isRetrying) {
                  _this.getChargesForOrder(true, isBypassingReachedBuyLimit ? true : false);
                }
              case 17:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()).then(function (_) {
        _this.$EventBus.$emit("loading", false);
      });
    },
    computeCharges: function computeCharges(db) {
      this.expedition_methods = this.getAvailableExpeditionMethods(db);
      this.expedition_methods = [].concat(_toConsumableArray(this.expedition_methods.filter(function (m) {
        return m.expedition_method !== 6;
      })), _toConsumableArray(this.expedition_methods.filter(function (m) {
        return m.expedition_method === 6;
      })));
      this.initShippingMethod();
      var groupedShippingMethodsByDeparture = this.expedition_methods.reduce(function (acc, x) {
        if (!acc[x.departureWarehouseId]) return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, [x]));
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, [].concat(_toConsumableArray(acc[x.departureWarehouseId]), [x])));
      }, {});

      // Compute order shipping amount
      var _this = this;
      Object.values(groupedShippingMethodsByDeparture).forEach(function (x) {
        var _x2 = _slicedToArray(x, 1),
          anyShippingMethod = _x2[0];
        if (x.length === 1) {
          _this.order.expedition_methods[anyShippingMethod.departureWarehouseId] = anyShippingMethod;
        }
        _this.order.items.filter(function (e) {
          return anyShippingMethod.itemIds.includes(e.id_item);
        }).forEach(function (e) {
          if (x.length === 1) e.expeditionMethod = anyShippingMethod.expedition_method;
          if (!e.expeditionMethod) {
            var itemWithExistingShippingMethod = _this.order.items.filter(function (it) {
              return anyShippingMethod.itemIds.includes(it.id_item);
            }).find(function (it) {
              return !!it.expeditionMethod;
            });
            if (itemWithExistingShippingMethod) {
              e.expeditionMethod = itemWithExistingShippingMethod.expeditionMethod;
            }
          }
          if (!!e.expeditionMethod) {
            var shippingMethod = x.find(function (s) {
              return s.id === e.expeditionMethod;
            });
            if (shippingMethod) {
              e.totalShippingCurrency = shippingMethod.price_numeric_currency;
              e.shippingAmount = e.totalShippingCurrency / anyShippingMethod.itemIds.length;
            }
          }
        });
      });
      var shippingAmount = this.order.items.reduce(function (acc, x) {
        return acc + x.shippingAmount || 0;
      }, 0);
      var totalAmountCurrency = shippingAmount + this.order.items.reduce(function (acc, x) {
        return acc + x.unit_price_currency * x.quantity;
      }, 0);
      this.order = _objectSpread(_objectSpread({}, this.order), {}, {
        amount_shipping_currency: shippingAmount,
        total_amount_currency: totalAmountCurrency,
        total_amount_currency_include_credit_notes: totalAmountCurrency - this.order.credit_notes_amount_currency
      });
      this.mustRecalculateCharges = false;
    },
    initShippingMethod: function initShippingMethod() {
      var _this5 = this;
      if (this.expedition_methods.length === 1 && !this.expedition_methods[0].isError) {
        var _this$expedition_meth = this.expedition_methods[0],
          eta_min_hours = _this$expedition_meth.eta_min_hours,
          eta_max_hours = _this$expedition_meth.eta_max_hours,
          expedition_method = _this$expedition_meth.expedition_method;
        this.order.expedition_method = expedition_method;
        this.order.items.forEach(function (x) {
          return x.expeditionMethod = expedition_method;
        });
        this.order.eta_min_hours = eta_min_hours;
        this.order.eta_max_hours = eta_max_hours;
      }
      this.order.expedition_methods = this.expedition_methods.reduce(function (acc, x) {
        var item = _this5.order.items.find(function (e) {
          return x.itemIds.includes(e.id_item);
        });
        if (item && item.expeditionMethod === x.expedition_method) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.departureWarehouseId, x));
        }
        return acc;
      }, {});
    },
    getAvailableExpeditionMethods: function getAvailableExpeditionMethods(db) {
      var _this6 = this;
      return db.expedition_prices.map(function (x) {
        if ((x === null || x === void 0 ? void 0 : x.expedition_price) >= 0) {
          var method_ref = Object.values(_this6.expedition_methods_ref).filter(function (ep) {
            return ep.id === x.expedition_method;
          })[0];
          var priceExp = x.expeditionPriceCurrency;
          return _objectSpread(_objectSpread({}, x), {}, {
            id: x.expedition_method,
            departureWarehouseId: x.departureWarehouseId,
            icon: method_ref.faIcon,
            label: method_ref.text,
            price_numeric_currency: priceExp,
            price_label: "+ ".concat(formatPrice(priceExp / x.itemIds.length), " ").concat(_this6.getSymbolCurrency(_this6.order.currency), " / bottle"),
            price_global_label: formatPrice(priceExp) + " " + _this6.getSymbolCurrency(_this6.order.currency),
            eta_label: _this6.getEtaLabel(x.eta_min_hours, x.eta_max_hours),
            original_object: x
          });
        }
      });
    },
    getEtaLabel: function getEtaLabel(eta_min_hours, eta_max_hours) {
      var unit = eta_min_hours > 72 || eta_max_hours && eta_max_hours > 72 ? "days" : "hours";
      if (unit === "days") {
        return Math.ceil(eta_min_hours / 24) + (eta_max_hours ? "-" + Math.ceil(eta_max_hours / 24) : "") + " " + unit;
      } else {
        return eta_min_hours + (eta_max_hours ? "-" + eta_max_hours : "") + " " + unit;
      }
    },
    computeCasings: function computeCasings() {
      var _this7 = this;
      this.order.items.map(function (x) {
        return x.wine.casings = _this7.casingsAvailable(x);
      });
    },
    casingsAvailable: function casingsAvailable(item) {
      var wineCasings = item.wine.casings.map(function (wc) {
        return _objectSpread(_objectSpread({}, wc), {}, {
          textCard: casingWines.find(function (x) {
            return x.value == wc.casingId;
          }).textCard
        });
      });
      wineCasings.sort(function (a, b) {
        return a.quantity - b.quantity;
      });
      if (!wineCasings.some(function (x) {
        return x.quantity == 1;
      })) {
        wineCasings.unshift(casingForAdmin());
      }
      return wineCasings;
    },
    editItemPrice: function editItemPrice(item) {
      var _this8 = this;
      this.currentItemForWineStockChanged = item;
      this.editOrderItemPriceDialogShown = true;
      this.$nextTick(function () {
        _this8.$refs.EditOrderItemPriceDialog.open();
      });
    },
    confirmItemPrice: function confirmItemPrice() {
      var _this9 = this;
      this.editOrderItemPriceDialogShown = false;
      this.$nextTick(function () {
        _this9.currentItemForWineStockChanged = null;
      });

      // Reload the order
      this.getChargesForOrder();
    },
    cancelEditOrderItemPriceDialog: function cancelEditOrderItemPriceDialog() {
      var _this10 = this;
      this.editOrderItemPriceDialogShown = false;
      this.$nextTick(function () {
        _this10.currentItemForWineStockChanged = null;
      });
    },
    deleteItem: function deleteItem(itemId) {
      this.deleteItemCreated(itemId);
    },
    deleteItemCreated: function deleteItemCreated(itemId) {
      var _this11 = this;
      this.errorLabels.quantity_orders = [];
      this.$refs.confirm.open("Delete", "Are you sure you want to delete this product ?", {
        color: "red"
      }).then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(confirm) {
          var item, _this12;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (!confirm) {
                  _context4.next = 9;
                  break;
                }
                _this11.mustRecalculateCharges = true;
                _this11.$EventBus.$emit("loading", true);
                item = _this11.order.items.find(function (x) {
                  return x.id_item === itemId;
                });
                _this11.order.items.splice(_this11.order.items.indexOf(item), 1);
                _context4.next = 7;
                return _this11.resetLogisticDetails();
              case 7:
                _this12 = _this11;
                request("/v1/order", "put", _this12.order, true, "api").then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  var _yield$orderHandler$f, data;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(_this12.order.items.length === 0)) {
                          _context3.next = 6;
                          break;
                        }
                        _context3.next = 3;
                        return _this12.emptyBasket();
                      case 3:
                        _this12.$EventBus.$emit("BasketRemoved", true);
                        _context3.next = 17;
                        break;
                      case 6:
                        _context3.next = 8;
                        return orderHandler.fetchBasket();
                      case 8:
                        _yield$orderHandler$f = _context3.sent;
                        data = _yield$orderHandler$f.data;
                        _this12.$EventBus.$emit("ItemRemoved", {
                          detail: {
                            items: data.items
                          }
                        });
                        _this12.order = data;
                        _this12.computeCasings();
                        orderHandler.setCurrentOrder(data);
                        _this12.getChargesForOrder();
                        _context3.next = 17;
                        return _this12.dispatchItemsInStorageLocations();
                      case 17:
                        if (_this12.order.items.length == 0) {
                          _this12.$EventBus.$emit("loading", false);
                        }
                      case 18:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                })));
              case 9:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    changeQuantityOrder: function changeQuantityOrder(item, quantity, groupedItems) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var casing, itemRef, lastExpeditionMethod;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this13.isChangingQuantity = true;
              casing = item.casingId.match(/\d+/)[0];
              quantity = quantity * casing;
              _this13.errorLabels.quantity_orders = [];
              _this13.$EventBus.$emit("loading", true);
              itemRef = _this13.order.items.find(function (x) {
                return x.id_item === item.id_item;
              });
              itemRef.quantity = quantity;
              itemRef.casingId = item.casingId;
              itemRef.total_amount = item.quantity * item.unit_price;
              lastExpeditionMethod = _objectSpread({}, _this13.expedition_methods.find(function (x) {
                return x.id === item.expeditionMethod;
              }));
              _context5.next = 12;
              return _this13.resetLogisticDetails();
            case 12:
              if (itemRef.quantity == 0) {
                // if the quantity of the item is down to 0, we delete the item of the cart and from the order
                _this13.order.items.splice(_this13.order.items.indexOf(itemRef), 1);
              }
              if (!(_this13.order.items.length === 0)) {
                _context5.next = 19;
                break;
              }
              _context5.next = 16;
              return _this13.emptyBasket();
            case 16:
              _this13.$EventBus.$emit("BasketRemoved", true);
              _this13.isChangingQuantity = false;
              return _context5.abrupt("return");
            case 19:
              _this13.mustRecalculateCharges = true;
              _this13.order.items.filter(function (x) {
                return groupedItems.map(function (gi) {
                  return gi.id_item;
                }).includes(x.id_item);
              }).forEach(function (x) {
                _this13.order.items.splice(_this13.order.items.indexOf(x), 1, _objectSpread(_objectSpread({}, x), {}, {
                  expeditionMethod: lastExpeditionMethod.id
                }));
              });
              _context5.next = 23;
              return _this13.getChargesForOrder();
            case 23:
              _this13.isChangingQuantity = false;
            case 24:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    updateDeliveryInstructions: function updateDeliveryInstructions() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this14$updateDeliver;
        var path, data;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              (_this14$updateDeliver = _this14.updateDeliveryInstructionsToken) === null || _this14$updateDeliver === void 0 || _this14$updateDeliver.cancel();
              _this14.updateDeliveryInstructionsToken = axios.CancelToken.source();
              path = "/v1/orders/" + _this14.order.id_order + "/delivery-instructions";
              data = {
                DeliveryInstructions: _this14.order.delivery_instructions,
                isSetAsDefaultForUserAddress: _this14.isSetDeliveryAddressAsDefaultForUserAddress
              };
              _context6.next = 6;
              return request(path, "put", data, true, "api", null, _this14.updateDeliveryInstructionsToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to update delivery instructions.", {
                    type: "error"
                  });
                  return;
                }
              });
            case 6:
              _this14.editingDeliveryInstructions = false;
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    isOrderDeliveryInstructionsDefaultUser: function isOrderDeliveryInstructionsDefaultUser() {
      return String.isNullOrEmpty(this.order.delivery_instructions) && String.isNullOrEmpty(this.order.delivery_address.deliveryInstructions) || this.order.delivery_instructions === this.order.delivery_address.deliveryInstructions;
    },
    initWineStockList: function initWineStockList() {
      this.wineStockKey = null;
      this.currentWine = null;
      this.currentItemForWineStockChanged = null;
      this.currentQuantity = 1;
      this.currentCasingId = "OC1";
    },
    closeWineStockListModal: function closeWineStockListModal() {
      var _this15 = this;
      this.$nextTick(function () {
        _this15.initWineStockList();
      });
    },
    isChangeStockAvailable: function isChangeStockAvailable(item) {
      var _item$wine$stocks,
        _this16 = this;
      return (_item$wine$stocks = item.wine.stocks) === null || _item$wine$stocks === void 0 ? void 0 : _item$wine$stocks.some(function (x) {
        return x.id_stock !== item.wine.id_stock && (x.status !== wineStockStatus.UNAVAILABLE || hasRole(process.env.VUE_APP_ROLES_BYPASS_STOCK_RESERVATION)) && (x.stock_countries.length === 0 || x.stock_countries.some(function (y) {
          return y.id_country === _this16.order.delivery_address.country.id_country;
        }));
      });
    },
    changeStockItem: function changeStockItem(item, groupedItems) {
      var _this17 = this;
      this.wineStockKey = item.wine.id_wine;
      this.currentWine = _objectSpread({}, item.wine);
      this.currentItemForWineStockChanged = item;
      this.currentGroupedItemsForWineStockChanged = groupedItems;
      this.currentQuantity = item.quantity / item.casingId.match(/\d+/)[0];
      this.currentCasingId = item.casingId;
      this.$nextTick(function () {
        _this17.$refs.WineStockListModal.open();
      });
    },
    changeWineStockOrder: function changeWineStockOrder(item, quantity, casingId, groupedItems) {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this18$changeWineSto;
        var bottleQuantities, path, data, lastExpeditionMethod, itemRef, _e$response6, _e$response7, isBypassingReachedBuyLimit, _e$response$data$valu2, errorMessage;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this18.$EventBus.$emit("loading", true);
              _this18.isChangingQuantity = true;
              (_this18$changeWineSto = _this18.changeWineStockCancellationToken) === null || _this18$changeWineSto === void 0 || _this18$changeWineSto.cancel();
              _this18.changeWineStockCancellationToken = axios.CancelToken.source();
              _context7.prev = 4;
              bottleQuantities = quantity * casingId.match(/\d+/)[0];
              path = "/v1/order/".concat(_this18.order.id_order, "/item/stock");
              data = {
                itemId: item.id_item,
                wineId: item.wine.id_wine,
                stockId: item.wine.id_stock,
                quantity: bottleQuantities,
                casingId: casingId,
                isBasket: true
              };
              _context7.next = 10;
              return request(path, "put", data, true, "api", null, _this18.changeWineStockCancellationToken);
            case 10:
              lastExpeditionMethod = _objectSpread({}, _this18.expedition_methods.find(function (x) {
                return x.id === item.expeditionMethod;
              }));
              itemRef = _this18.order.items.find(function (x) {
                return x.id_item === item.id_item;
              });
              itemRef.quantity = bottleQuantities;
              itemRef.casingId = casingId;
              itemRef.total_amount = itemRef.quantity * item.unit_price;
              _this18.order.items.filter(function (x) {
                return groupedItems.map(function (gi) {
                  return gi.id_item;
                }).includes(x.id_item);
              }).forEach(function (x) {
                _this18.order.items.splice(_this18.order.items.indexOf(x), 1, _objectSpread(_objectSpread({}, x), {}, {
                  expeditionMethod: lastExpeditionMethod.id
                }));
              });
              _this18.mustRecalculateCharges = true;
              _context7.next = 19;
              return _this18.getChargesForOrder();
            case 19:
              _this18.$toasted.show("Product stock changed", {
                type: "success"
              });
              _context7.next = 42;
              break;
            case 22:
              _context7.prev = 22;
              _context7.t0 = _context7["catch"](4);
              if (axios.isCancel(_context7.t0)) {
                _context7.next = 42;
                break;
              }
              if (!((_e$response6 = _context7.t0.response) !== null && _e$response6 !== void 0 && (_e$response6 = _e$response6.data) !== null && _e$response6 !== void 0 && _e$response6.value)) {
                _context7.next = 41;
                break;
              }
              _this18.$toasted.show(_context7.t0.response.data.value.errorMessage, {
                type: "warning"
              });
              isBypassingReachedBuyLimit = null;
              if (!((_context7.t0 === null || _context7.t0 === void 0 || (_e$response7 = _context7.t0.response) === null || _e$response7 === void 0 || (_e$response7 = _e$response7.data) === null || _e$response7 === void 0 || (_e$response7 = _e$response7.value) === null || _e$response7 === void 0 ? void 0 : _e$response7.errorCode) === buyLimitErrors.BUY_LIMIT_REACHED.value && hasRole(process.env.VUE_APP_ROLES_BYPASS_ALL_BUY_LIMITS))) {
                _context7.next = 34;
                break;
              }
              _this18.$toasted.clear();
              errorMessage = (_e$response$data$valu2 = _context7.t0.response.data.value.errorMessage) !== null && _e$response$data$valu2 !== void 0 ? _e$response$data$valu2 : _context7.t0.response.data.value.errorMessage;
              _context7.next = 33;
              return _this18.$refs.confirm.open("Bypass buy limits for order", "".concat(errorMessage, "  ").concat(buyLimitErrors.BUY_LIMIT_REACHED.text), {
                color: "red"
              });
            case 33:
              isBypassingReachedBuyLimit = _context7.sent;
            case 34:
              if (!isBypassingReachedBuyLimit) {
                _context7.next = 39;
                break;
              }
              _context7.next = 37;
              return request("/v1/order/".concat(_this18.order.id_order, "/bypass"), "put", null, true, "api");
            case 37:
              _context7.next = 39;
              return _this18.getChargesForOrder(true, true);
            case 39:
              _context7.next = 42;
              break;
            case 41:
              _this18.$toasted.show("An error occured. Please contact an administrator.", {
                type: "error"
              });
            case 42:
              _context7.prev = 42;
              _this18.isChangingQuantity = false;
              _this18.$EventBus.$emit("loading", false);
              return _context7.finish(42);
            case 46:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[4, 22, 42, 46]]);
      }))();
    },
    addWineFromWineStockList: function addWineFromWineStockList(wine, casingId) {
      var isFromWineStockModal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var quantityFromStockModal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      this.wineStockKey = null;
      if (this.currentItemForWineStockChanged) {
        this.currentItemForWineStockChanged.wine = wine;
        this.changeWineStockOrder(this.currentItemForWineStockChanged, quantityFromStockModal, casingId, this.currentGroupedItemsForWineStockChanged);
      }
    },
    ungrantedAccessItems: function ungrantedAccessItems() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this = _this19;
              if (!hasRole(process.env.VUE_APP_ROLES_BYPASS_RANGE_ACCESSIBILITY)) {
                _context8.next = 3;
                break;
              }
              return _context8.abrupt("return", false);
            case 3:
              _context8.next = 5;
              return request("/v1/category-users/".concat(_this19.order.user.id_user, "/ungranted-access-items/").concat(_this19.order.id_order), "get", null, true, "api", null).catch(function (e) {
                var _e$response8;
                var _e$response$data = e === null || e === void 0 || (_e$response8 = e.response) === null || _e$response8 === void 0 ? void 0 : _e$response8.data,
                  value = _e$response$data.value;
                if (value) {
                  _this.$toasted.show(value.errorMessage, {
                    type: "warning"
                  });
                }
                throw e;
              });
            case 5:
              response = _context8.sent;
              if (!((response === null || response === void 0 ? void 0 : response.data.value.length) > 0)) {
                _context8.next = 9;
                break;
              }
              response.data.value.forEach(function (itemId) {
                var item = _this.order.items.find(function (x) {
                  return x.id_item == itemId;
                });
                _this.$toasted.show("".concat(item.wine.display_name, " ").concat(listWineRangeAccessibility.find(function (z) {
                  return z.id == item.wine.rangeAccessibility;
                }).textForProductFilters), {
                  type: "warning"
                });
              });
              return _context8.abrupt("return", true);
            case 9:
              return _context8.abrupt("return", false);
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    sendOrderToUser: function sendOrderToUser() {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var orderHasMultipleDepartures, orderId, _this21;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this20.ungrantedAccessItems();
            case 2:
              if (!_context11.sent) {
                _context11.next = 4;
                break;
              }
              return _context11.abrupt("return");
            case 4:
              if (!_this20.checkInputsPayment()) {
                _context11.next = 11;
                break;
              }
              _this20.$EventBus.$emit("loading", true);
              orderHasMultipleDepartures = _this20.orderHasMultipleDepartures;
              orderId = _this20.order.id_order;
              _this21 = _this20;
              _context11.next = 11;
              return request("/v1/order", "put", _this21.order, true, "api").then(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(response) {
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        _context10.next = 2;
                        return request("/v1/order/" + _this21.order.id_order + "/state/" + orderStatus.filter(function (os) {
                          return os.id === "AWAITING_CUSTOMER_VALIDATION";
                        })[0].status, "put", {}, true, "api").then(/*#__PURE__*/function () {
                          var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(responseUpdate) {
                            return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                              while (1) switch (_context9.prev = _context9.next) {
                                case 0:
                                  orderHandler.removeOrderFromStorage();
                                  _this21.$EventBus.$emit("BasketRemoved");
                                  _this21.$EventBus.$emit("ItemRemoved", {
                                    detail: {
                                      items: []
                                    }
                                  });
                                  if (!orderHasMultipleDepartures) {
                                    _this21.$router.push({
                                      name: "adminOrderSummary",
                                      params: {
                                        id: orderId
                                      }
                                    });
                                  } else {
                                    _this21.$router.push({
                                      name: "adminOrderList",
                                      query: {
                                        tab: "orders"
                                      }
                                    });
                                  }
                                  _this21.$EventBus.$emit("loading", false);
                                  _this21.$toasted.show("Order has been sent to user for validation.", {
                                    type: "success"
                                  });
                                case 6:
                                case "end":
                                  return _context9.stop();
                              }
                            }, _callee9);
                          }));
                          return function (_x5) {
                            return _ref6.apply(this, arguments);
                          };
                        }()).catch(function (_) {
                          _this21.$EventBus.$emit("loading", false);
                          _this21.$toasted.show("An error occured. Please contact an administrator.", {
                            type: "error"
                          });
                        });
                      case 2:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x4) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 11:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    confirmOrderForCustomer: function confirmOrderForCustomer() {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var orderHasMultipleDepartures, orderId, _this23, data;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return _this22.ungrantedAccessItems();
            case 2:
              if (!_context14.sent) {
                _context14.next = 4;
                break;
              }
              return _context14.abrupt("return");
            case 4:
              if (!_this22.checkInputsPayment()) {
                _context14.next = 12;
                break;
              }
              _this22.$EventBus.$emit("loading", true);
              orderHasMultipleDepartures = _this22.orderHasMultipleDepartures;
              orderId = _this22.order.id_order;
              _this23 = _this22;
              data = {
                send_mails: false
              };
              _context14.next = 12;
              return request("/v1/order", "put", _this23.order, true, "api").then(/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(response) {
                  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                    while (1) switch (_context13.prev = _context13.next) {
                      case 0:
                        _context13.next = 2;
                        return request("/v1/order/" + _this23.order.id_order + "/state/" + orderStatus.find(function (x) {
                          return x.id === "AWAITING_VALIDATION";
                        }).status, "put", data, true, "api").then(/*#__PURE__*/function () {
                          var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(responseUpdate) {
                            return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                              while (1) switch (_context12.prev = _context12.next) {
                                case 0:
                                  orderHandler.removeOrderFromStorage();
                                  _this23.$EventBus.$emit("BasketRemoved");
                                  _this23.$EventBus.$emit("ItemRemoved", {
                                    detail: {
                                      items: []
                                    }
                                  });
                                  if (!orderHasMultipleDepartures) {
                                    _this23.$router.push({
                                      name: "adminOrderSummary",
                                      params: {
                                        id: orderId
                                      }
                                    });
                                  } else {
                                    _this23.$router.push({
                                      name: "adminOrderList",
                                      query: {
                                        tab: "orders"
                                      }
                                    });
                                  }
                                  _this23.$EventBus.$emit("loading", false);
                                  _this23.$toasted.show("Order is waiting for administrator validation.", {
                                    type: "success"
                                  });
                                case 6:
                                case "end":
                                  return _context12.stop();
                              }
                            }, _callee12);
                          }));
                          return function (_x7) {
                            return _ref8.apply(this, arguments);
                          };
                        }()).catch(function (_) {
                          _this23.$EventBus.$emit("loading", false);
                          _this23.$toasted.show("An error occured. Please contact an administrator.", {
                            type: "error"
                          });
                        });
                      case 2:
                      case "end":
                        return _context13.stop();
                    }
                  }, _callee13);
                }));
                return function (_x6) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 12:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    changeExpeditionMethod: function changeExpeditionMethod(shipItem, groupedItems) {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var _lastExpeditionMethod, _lastExpeditionMethod2;
        var lastExpeditionMethods, _lastExpeditionMethod3, isDeselectingCellar, confirmed, _this25;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this24.errorLabels.quantity_orders = [];
              _this24.errorLabels.shipping = {};
              if (!_this24.order.expedition_methods) _this24.order.expedition_methods = {};
              lastExpeditionMethods = _objectSpread({}, _this24.order.expedition_methods);
              if (!((shipItem.expedition_method === expeditionMethods.CELLAR_STORAGE.id || ((_lastExpeditionMethod = lastExpeditionMethods[shipItem.departureWarehouseId]) === null || _lastExpeditionMethod === void 0 ? void 0 : _lastExpeditionMethod.id) === expeditionMethods.CELLAR_STORAGE.id) && shipItem.expedition_method !== ((_lastExpeditionMethod2 = lastExpeditionMethods[shipItem.departureWarehouseId]) === null || _lastExpeditionMethod2 === void 0 ? void 0 : _lastExpeditionMethod2.id))) {
                _context15.next = 22;
                break;
              }
              isDeselectingCellar = ((_lastExpeditionMethod3 = lastExpeditionMethods[shipItem.departureWarehouseId]) === null || _lastExpeditionMethod3 === void 0 ? void 0 : _lastExpeditionMethod3.id) === expeditionMethods.CELLAR_STORAGE.id;
              _context15.next = 8;
              return _this24.$refs.confirm.open("To your attention", isDeselectingCellar ? "When deselecting this type of shipment, be aware that duties and taxes will be included in the products. Wine's prices will be update." : "When choosing the type of shipment « stored at the cellar », please be aware that duties and taxes will no longer be included on the products and may be charged to you later by the financial authorities. Wine prices will be updated.", {
                color: "warning"
              });
            case 8:
              confirmed = _context15.sent;
              if (!confirmed) {
                _context15.next = 18;
                break;
              }
              _this24.$EventBus.$emit("loading", true);
              if (!_this24.orderHasMultipleDepartures) {
                _this24.order.expedition_method = shipItem.expedition_method;
                _this24.order.eta_min_hours = shipItem.eta_min_hours;
                _this24.order.eta_max_hours = shipItem.eta_max_hours;
              }
              _this24.order.expedition_methods[shipItem.departureWarehouseId] = shipItem;
              _this24.computeShippingAmount(groupedItems, shipItem.id, shipItem.price_numeric_currency);
              _this25 = _this24;
              request("/v1/order", "put", _this25.order, true, "api").then(function (response) {
                _this25.$EventBus.$emit("loading", false);
                _this25.$nextTick(function () {
                  _this25.order = _objectSpread(_objectSpread({}, _this25.order), {}, {
                    expedition_methods: _objectSpread(_objectSpread({}, _this25.order.expedition_methods), {}, _defineProperty({}, shipItem.departureWarehouseId, shipItem))
                  }, response.data);
                  _this25.computeCasings();
                  _this25.computeShippingAmount(groupedItems, shipItem.id, shipItem.price_numeric_currency);
                  orderHandler.setCurrentOrder(_this25.order);
                });
              });
              _context15.next = 20;
              break;
            case 18:
              _this24.order = _objectSpread(_objectSpread({}, _this24.order), {}, {
                expedition_methods: _objectSpread({}, lastExpeditionMethods)
              });
              return _context15.abrupt("return");
            case 20:
              _context15.next = 25;
              break;
            case 22:
              if (!_this24.orderHasMultipleDepartures) {
                _this24.order.expedition_method = shipItem.expedition_method;
                _this24.order.eta_min_hours = shipItem.eta_min_hours;
                _this24.order.eta_max_hours = shipItem.eta_max_hours;
              }
              _this24.order.expedition_methods[shipItem.departureWarehouseId] = shipItem;
              _this24.computeShippingAmount(groupedItems, shipItem.id, shipItem.price_numeric_currency);
            case 25:
              orderHandler.setCurrentOrder(_this24.order);
              _this24.$nextTick(function () {
                _this24.order.expedition_methods = _objectSpread(_objectSpread({}, _this24.order.expedition_methods), {}, _defineProperty({}, shipItem.departureWarehouseId, shipItem));
              });
            case 27:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    computeShippingAmount: function computeShippingAmount(groupedItems, shippingMethod, totalShippingCurrency) {
      var _this26 = this;
      var _iterator = _createForOfIteratorHelper(groupedItems),
        _step;
      try {
        var _loop = function _loop() {
          var groupedItem = _step.value;
          var item = _this26.order.items.find(function (i) {
            return i.id_item === groupedItem.id_item;
          });
          var index = _this26.order.items.indexOf(item);
          _this26.order.items.splice(index, 1, _objectSpread(_objectSpread({}, item), {}, {
            expeditionMethod: shippingMethod,
            totalShippingCurrency: totalShippingCurrency
          }));
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!this.orderHasMultipleDepartures) {
        var shippingAmount = this.groupedItemsByDeparture.reduce(function (acc, x, i) {
          var _x$;
          if (i === _this26.groupedItemsByDeparture.indexOf(groupedItems)) return acc;
          return acc + (((_x$ = x[0]) === null || _x$ === void 0 ? void 0 : _x$.totalShippingCurrency) || 0);
        }, 0);
        var totalAmountCurrency = shippingAmount + this.order.items.reduce(function (acc, x) {
          return acc + x.unit_price_currency * x.quantity;
        }, 0);
        this.order = _objectSpread(_objectSpread({}, this.order), {}, {
          amount_shipping_currency: shippingAmount,
          total_amount_currency: totalAmountCurrency,
          total_amount_currency_include_credit_notes: totalAmountCurrency - this.order.credit_notes_amount_currency
        });
      }
    },
    resetLogisticDetails: function resetLogisticDetails() {
      var _this27 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this, path;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this = _this27;
              _context16.prev = 1;
              _this27.order.expedition_methods = [];
              _this27.order.expedition_method = 0;
              _this27.order.eta_min_hours = 0;
              _this27.order.eta_max_hours = null;
              _this27.order.amount_shipping_currency = null;
              _this27.order.items = _this27.order.items.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  expeditionMethod: null
                });
              });
              path = "/v1/orders/".concat(_this27.order.id_order, "/logistic-details/");
              _context16.next = 11;
              return request(path, "delete", {}, true, "api");
            case 11:
              _context16.next = 16;
              break;
            case 13:
              _context16.prev = 13;
              _context16.t0 = _context16["catch"](1);
              _this.$toasted.show("An error occured. Please contact an administrator.", {
                type: "error"
              });
            case 16:
            case "end":
              return _context16.stop();
          }
        }, _callee16, null, [[1, 13]]);
      }))();
    },
    confirmDeliveryAddress: function confirmDeliveryAddress() {
      return Promise.resolve();
    },
    computeAddressStockConsignment: function computeAddressStockConsignment(item) {
      if (item.wine.stock_storage_continent_iso2) {
        return " stored in " + listContinents.find(function (x) {
          return x.id == item.wine.stock_storage_continent_iso2;
        }).display_name;
      } else {
        return item.wineryAddress.city + (item.wineryAddress.zip ? " " + item.wineryAddress.zip : "") + ", " + item.wineryAddress.country.printable_name + (item.wineryAddress.state.id_state ? " " + item.wineryAddress.state.state_label : "");
      }
    },
    checkInputs: function checkInputs() {
      var _this28 = this,
        _this$itemsRequiringT;
      var valid = true;
      this.errorLabels.shipping = {};
      var _this$groupedItemsByD3 = this.groupedItemsByDeparture.filter(function (x) {
          return x.some(function (i) {
            return !i.expeditionMethod || _this28.expedition_methods.filter(function (e) {
              return !e.isError;
            }).filter(function (e) {
              return e.itemIds.includes(i.id_item);
            }).every(function (e) {
              return i.expeditionMethod !== e.expedition_method;
            });
          });
        }),
        _this$groupedItemsByD4 = _slicedToArray(_this$groupedItemsByD3, 1),
        shippingMethods = _this$groupedItemsByD4[0];
      if (!!(shippingMethods !== null && shippingMethods !== void 0 && shippingMethods.length)) {
        this.errorLabels.shipping = shippingMethods.reduce(function (acc, x) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x.shippingMethods[0].departureWarehouseId, _this28.errorMessages.shippingType.required));
        }, {});
        valid = false;
      }
      this.errorLabels.tastingPhoto = "";
      if (((_this$itemsRequiringT = this.itemsRequiringTastingPhoto) === null || _this$itemsRequiringT === void 0 ? void 0 : _this$itemsRequiringT.length) > 0) {
        var itemIdsRequiringTastingPhoto = this.itemsRequiringTastingPhoto.map(function (x) {
          return x.id_item;
        });
        if (itemIdsRequiringTastingPhoto.some(function (id) {
          return !_this28.checkboxTastingPhoto[id];
        })) {
          this.errorLabels.tastingPhoto = this.errorMessages.tastingPhoto.required;
          valid = false;
        }
      }
      if (this.thirdPartyUserSelected == null) {
        this.errorLabels.user_selected = this.errorMessages.mandatory;
        valid = false;
      }
      return valid;
    },
    checkInputsPayment: function checkInputsPayment() {
      var _this29 = this;
      var valid = this.checkInputs();
      this.errorLabels.quantity_orders = [];
      var amountCurrencyByPassVolume = getPriceValueInUsedCurrencyForCartAndExplore(+this.$whitelabel.orderLimitMinPriceWithoutShipping);
      var isMultiDeparture = this.groupedItemsByDeparture.length > 1;
      var invalidOrders = [];
      if (!!invalidOrders.length) {
        valid = false;
        this.errorLabels.quantity_orders = invalidOrders.map(function (_ref9) {
          var _ref10 = _slicedToArray(_ref9, 1),
            x = _ref10[0];
          var _x$shippingMethods = _slicedToArray(x.shippingMethods, 1),
            shippingMethod = _x$shippingMethods[0];
          return {
            anchor: shippingMethod.id,
            text: "Minimum order quantity of " + parseInt(_this29.$whitelabel.orderLimitMinVolume / REGULAR_BOTTLING) + " bottles (" + _this29.$whitelabel.orderLimitMinVolume / 1000 + "L) or " + _this29.formatPrice(amountCurrencyByPassVolume) + " " + _this29.getSymbolCurrency(_this29.order.currency) + " of total value" + (isMultiDeparture ? " per departure" : "")
          };
        });
      }
      return valid;
    },
    changeItemRemoved: function changeItemRemoved(event) {
      this.order.items = _toConsumableArray(event.detail.items);
      this.mustRecalculateCharges = true;
    },
    redirectToWineCatalog: function redirectToWineCatalog() {
      var _this$$route;
      if (this.order.items.length == 0 && ((_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : _this$$route.name) !== "adminProductList") {
        this.$router.push({
          name: "adminProductList"
        });
      }
    },
    startEditOrderCurrency: function startEditOrderCurrency() {
      var _this30 = this;
      this.editingOrderCurrency = true;
      this.initialCurrency = this.order.currency;
      this.$nextTick(function (_) {
        _this30.$refs.inputOrderCurrency.focus();
      });
    },
    updateOrderCurrency: function updateOrderCurrency() {
      var _this31 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this31$updateOrderCu;
        var _this;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _this31.isUpdatingOrderCurrency = true;
              (_this31$updateOrderCu = _this31.updateOrderCurrencyToken) === null || _this31$updateOrderCu === void 0 || _this31$updateOrderCu.cancel();
              _this31.updateOrderCurrencyToken = axios.CancelToken.source();
              _this = _this31;
              _context17.next = 6;
              return request("/v1/order/currency", "post", {
                orderId: _this31.order.id_order,
                currency: _this31.order.currency
              }, true, "api", null, _this31.updateOrderCurrencyToken).catch(function (e) {
                _this.isUpdatingOrderCurrency = false;
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to change the currency.", {
                    type: "error"
                  });
                }
                throw e;
              });
            case 6:
              _context17.next = 8;
              return _this31.getChargesForOrder();
            case 8:
              _this31.editingOrderCurrency = false;
              _this31.isUpdatingOrderCurrency = false;
            case 10:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    startEditDeliveryInstructions: function startEditDeliveryInstructions() {
      var _this32 = this;
      this.editingDeliveryInstructions = true;
      this.$nextTick(function (_) {
        _this32.$refs.inputDeliveryInstruction.focus();
      });
    },
    dispatchItemsInStorageLocations: function dispatchItemsInStorageLocations() {
      var _this33 = this;
      this.storageLocations = {
        storageLocationsList: [],
        warehouses: []
      };
      this.storageLocations.storageLocationsList = this.order.items.map(function (item) {
        return item.warehouseName ? {
          warehouseId: item.warehouseId,
          warehouseName: item.warehouseName
        } : {
          warehouseId: item.warehouseId,
          warehouseName: "Direct Producer"
        };
      });
      this.storageLocations.storageLocationsList = _toConsumableArray(new Map(this.storageLocations.storageLocationsList.map(function (item) {
        return [item.warehouseId, item];
      })).values());
      this.storageLocations.storageLocationsList.forEach(function (x) {
        _this33.storageLocations.warehouses.push({
          id: x.warehouseId,
          name: x.warehouseId ? x.warehouseName : "Direct Producer",
          items: _this33.order.items.filter(function (y) {
            return y.warehouseId === x.warehouseId;
          }),
          isCollapsed: false
        });
      });
      this.sortItemByWinery();
    },
    sortItemByWinery: function sortItemByWinery() {
      var _this34 = this;
      this.storageLocations.warehouses.forEach(function (x, i) {
        _this34.storageLocations.warehouses[i].items.sort(function (a, b) {
          if (a.wine.producer.name < b.wine.producer.name) return -1;
          if (a.wine.producer.name > b.wine.producer.name) return 1;
          return 0;
        });
      });
    },
    editShippingQuantity: function editShippingQuantity(isCheckbox) {
      var _this35 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this35$editShippingQ;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              data = {};
              if (!isCheckbox) {
                _context18.next = 10;
                break;
              }
              if (!(!_this35.isShippingQuantity && _this35.order.shipping_quantity > 0)) {
                _context18.next = 7;
                break;
              }
              _this35.order.shipping_quantity = null;
              data = {};
              _context18.next = 8;
              break;
            case 7:
              return _context18.abrupt("return");
            case 8:
              _context18.next = 11;
              break;
            case 10:
              data = {
                quantity: _this35.order.shipping_quantity
              };
            case 11:
              _this35.isEditingShippingQuantity = true;
              (_this35$editShippingQ = _this35.editShippingQuantityToken) === null || _this35$editShippingQ === void 0 || _this35$editShippingQ.cancel();
              _this35.editShippingQuantityToken = axios.CancelToken.source();
              _this = _this35;
              _context18.next = 17;
              return request("/v1/order/".concat(_this35.order.id_order, "/shipping-quantity"), "put", data, true, "api", null, _this35.editShippingQuantityToken).catch(function (e) {
                _this.isEditingShippingQuantity = false;
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to edit the shipping quantity.", {
                    type: "error"
                  });
                  throw e;
                }
              });
            case 17:
              _context18.next = 19;
              return _this35.getChargesForOrder();
            case 19:
              _this35.isEditingShippingQuantity = false;
            case 20:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    getDefaultShippingCurrencyIncludedByDeparture: function getDefaultShippingCurrencyIncludedByDeparture(departureWarehouseId) {
      var shippingChosen = this.getShippingChosenForDeparture(departureWarehouseId);
      if ((shippingChosen === null || shippingChosen === void 0 ? void 0 : shippingChosen.expedition_method) === expeditionMethods.CELLAR_STORAGE.id) {
        return 0;
      } else {
        var _this$defaultShipping, _this$defaultShipping2;
        return roundToTwoDigit((_this$defaultShipping = (_this$defaultShipping2 = this.defaultShippingIncludedInItemsByDeparture) === null || _this$defaultShipping2 === void 0 || (_this$defaultShipping2 = _this$defaultShipping2.find(function (x) {
          return x.warehouseId === departureWarehouseId;
        })) === null || _this$defaultShipping2 === void 0 ? void 0 : _this$defaultShipping2.totalDefaultShippingCurrency) !== null && _this$defaultShipping !== void 0 ? _this$defaultShipping : 0);
      }
    },
    showShippingPriceMinusDefault: function showShippingPriceMinusDefault(shipItem, groupedItems) {
      return orderHandler.showShippingPriceMinusDefault(shipItem, groupedItems, this.order.currency);
    },
    shouldShowWarningDefaultShipping: function shouldShowWarningDefaultShipping(groupedItems) {
      this.getAnyShippingMethod(groupedItems).departureWarehouseId;
      var defaultShippingCurrencyIncluded = this.getDefaultShippingCurrencyIncludedByDeparture(this.getAnyShippingMethod(groupedItems).departureWarehouseId);
      var shippingMethods = this.getAnyGroupedItem(groupedItems).shippingMethods;
      return !shippingMethods.some(function (x) {
        return x.expedition_method !== expeditionMethods.CELLAR_STORAGE.id && x.expeditionPriceCurrency <= defaultShippingCurrencyIncluded;
      });
    },
    getSubtotalPriceForDeparture: function getSubtotalPriceForDeparture(groupedItems) {
      var itemsPrice = groupedItems.reduce(function (acc, x) {
        return acc + x.total_amount_currency;
      }, 0);
      var exempleItem = this.getAnyGroupedItem(groupedItems);
      var departureWarehouseId = this.getAnyShippingMethod(groupedItems).departureWarehouseId;
      var shippingMethodForDeparture = exempleItem.expeditionMethod;
      var shippingPrice = 0;
      if (shippingMethodForDeparture == null) {
        shippingPrice = +this.getDefaultShippingCurrencyIncludedByDeparture(departureWarehouseId);
      } else if (shippingMethodForDeparture != this.expeditionMethods.CELLAR_STORAGE.id) {
        var _this$getShippingChos, _this$getShippingChos2;
        shippingPrice = (_this$getShippingChos = (_this$getShippingChos2 = this.getShippingChosenForDeparture(departureWarehouseId)) === null || _this$getShippingChos2 === void 0 ? void 0 : _this$getShippingChos2.expeditionPriceCurrency) !== null && _this$getShippingChos !== void 0 ? _this$getShippingChos : 0;
      }
      return roundToTwoDigit(itemsPrice + shippingPrice);
    },
    getShippingChosenForDeparture: function getShippingChosenForDeparture(departureWarehouseId) {
      var _this$order13;
      if ((_this$order13 = this.order) !== null && _this$order13 !== void 0 && _this$order13.expedition_methods) {
        var _this$order$expeditio;
        return (_this$order$expeditio = this.order.expedition_methods[departureWarehouseId]) !== null && _this$order$expeditio !== void 0 ? _this$order$expeditio : null;
      } else {
        return null;
      }
    },
    getUnitPriceCurrencyForItem: function getUnitPriceCurrencyForItem(item, groupedItems) {
      var shippingChosen = this.getShippingChosenForDeparture(this.getAnyShippingMethod(groupedItems).departureWarehouseId);
      var unitPriceCurrency = item.unitPriceIncludeDefaultShippingCurrency;
      if ((shippingChosen === null || shippingChosen === void 0 ? void 0 : shippingChosen.expedition_method) === expeditionMethods.CELLAR_STORAGE.id) {
        unitPriceCurrency = item.unit_price_currency;
      }
      return unitPriceCurrency;
    },
    getOrderTotalIncludeCreditNoteCurrency: function getOrderTotalIncludeCreditNoteCurrency() {
      var _this36 = this;
      var total = 0;
      this.groupedItemsByDeparture.forEach(function (groupedItems) {
        total += +_this36.getSubtotalPriceForDeparture(groupedItems);
      });
      return total - +this.order.credit_notes_amount_currency;
    },
    isShippingOutOfRange: function isShippingOutOfRange(groupedItems) {
      var _this$getAnyGroupedIt;
      return ((_this$getAnyGroupedIt = this.getAnyGroupedItem(groupedItems).shippingMethods) === null || _this$getAnyGroupedIt === void 0 ? void 0 : _this$getAnyGroupedIt.length) === 1 && this.getAnyGroupedItem(groupedItems).shippingMethods[0].isOutOfRange;
    },
    getShippingOutOfRangeMessage: function getShippingOutOfRangeMessage(groupedItems) {
      var nbVariation = this.getAnyGroupedItem(groupedItems).shippingMethods[0].outOfRangeVariation;
      if (nbVariation > 0) {
        return "This volume should not get an available shipping method. You should add ".concat(nbVariation, " regular bottle").concat(nbVariation > 1 && "s");
      } else {
        return "This volume should not get an available shipping method. You should remove ".concat(nbVariation, " regular bottle").concat(nbVariation > 1 && "s");
      }
    },
    isShippingInErrorEvenSuperAdmin: function isShippingInErrorEvenSuperAdmin(groupedItems) {
      var _this$getAnyGroupedIt2;
      return ((_this$getAnyGroupedIt2 = this.getAnyGroupedItem(groupedItems).shippingMethods) === null || _this$getAnyGroupedIt2 === void 0 ? void 0 : _this$getAnyGroupedIt2.length) === 1 && this.getAnyGroupedItem(groupedItems).shippingMethods[0].isErrorEvenSuperAdmin;
    },
    isShippingInError: function isShippingInError(groupedItems) {
      var _this$getAnyGroupedIt3;
      return ((_this$getAnyGroupedIt3 = this.getAnyGroupedItem(groupedItems).shippingMethods) === null || _this$getAnyGroupedIt3 === void 0 ? void 0 : _this$getAnyGroupedIt3.length) === 1 && this.getAnyGroupedItem(groupedItems).shippingMethods[0].isError;
    },
    emptyBasket: function emptyBasket() {
      var _this37 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _this37.isRemovingCart = true;
              _this37.$EventBus.$emit("loading", true);
              _this = _this37;
              _context19.next = 5;
              return request("/v1/basket/" + _this.order.id_order, "delete", {
                orderId: _this.order.id_order
              }, true, "api").catch(function (e) {
                _this.isRemovingCart = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to empty cart.");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 5:
              _this37.isRemovingCart = false;
              orderHandler.removeOrderFromStorage();
              _this37.$EventBus.$emit("BasketRemoved");
              _this37.$EventBus.$emit("ItemRemoved", {
                detail: {
                  items: []
                }
              });
              orderHandler.refreshCategoryUser(_this);
              _this37.$EventBus.$emit("loading", false);
            case 11:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice,
    getFullNameUserHtml: getFullNameUserHtml,
    getFullNameUser: getFullNameUser,
    isHolding: isHolding,
    scrollTo: scrollTo
  },
  mounted: function mounted() {
    var _this38 = this;
    this.$EventBus.$on("BasketRemoved", function (redirect) {
      return redirect && _this38.redirectToWineCatalog();
    });
    this.$EventBus.$on("ItemRemoved", this.changeItemRemoved);
  },
  watch: {
    "order.expedition_methods": function orderExpedition_methods(newVal, oldVal) {
      this.lastExpeditionMethod = _objectSpread({}, oldVal);
    },
    "order.status": function orderStatus(newVal, oldVal) {
      this.order.resume_status = null;
    },
    hasBlockingNetworkError: function hasBlockingNetworkError(newVal, oldVal) {
      if (newVal === true) {
        var buttons = [{
          text: "Return to product list",
          iconClass: "fas fa-undo",
          to: {
            name: "adminProductList"
          }
        }];
        this.$refs[ERROR_DATA.ref].open(ERROR_DATA.DIALOG_TYPES.DIALOG_RELOAD.id, ERROR_DATA.DIALOG_TYPES.DIALOG_RELOAD.defaultCustomMessage, {
          hideDefaultMessage: true,
          showMessage: true
        }, null, null, buttons);
      }
    }
  }
};